import React, { useState, useMemo } from 'react'
import { oneOf } from 'prop-types'
import styled from '@emotion/styled'
import { useTitle } from 'react-use'
import Button from 'components/button'
import AButton from 'components/a-button'
import RouteLogo from 'components/route-logo'
import DownloadModal from 'components/download-modal'
import Accent from 'components/accent'
import iphoneImage from 'assets/route-iphone.png'
import isMobileDevice from 'utils/isMobileDevice'

const Background = styled.div`
  background: linear-gradient(180deg, #023646 0%, #05222a 66.84%) no-repeat
    center center fixed;
  background-size: cover;
  text-align: center;
  padding: 24px 25% 24px 25%;
  height: calc(100vh - 48px);
  position: fixed;
  @media (max-width: 600px) {
    padding: 24px 0 24px 0;
  }
`

const ImageWrapper = styled.div`
  margin: auto;
`

const IphoneImage = styled.img`
  max-height: 700px;
  display: block;
  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1),
    rgba(0, 0, 0, 1),
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0)
  );
  @media (max-width: 600px) {
    margin: 60px auto 24px auto;
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1),
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    );
  }
`

const Flex = styled.div`
  margin-top: 160px;
  display: inline-flex;
  @media (max-width: 600px) {
    margin-top: 32px;
    overflow-y: scroll;
    flex-wrap: wrap;
  }
`

const TextAndButton = styled.div`
  padding-top: 150px;
  padding-left: 60px;
  text-align: left;
  @media (max-width: 600px) {
    text-align: center;
    order: -1;
    padding-top: 0px;
    padding-left: 24px;
    padding-right: 24px;
  }
`

const Text = styled.p`
  font-weight: 700;
  font-size: 50px;
  line-height: 50px;
  color: white;
  @media (max-width: 600px) {
    font-size: 34px;
    line-height: 36px;
  }
`

const Scroll = styled.div`
  height: 100vh;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
`

const Default = ({ type }) => {
  useTitle('Discover - Download')
  const [modalOpen, setModalOpen] = useState(false)
  const isMobile = useMemo(isMobileDevice)
  return (
    <>
      <Background>
        <ImageWrapper>
          <RouteLogo textColor="white" />
        </ImageWrapper>
        <Scroll>
          <Flex>
            <IphoneImage src={iphoneImage} alt="route-iphone" />
            <TextAndButton>
              <Text>
                {`Someone shared ${type ? `a ${type}` : 'something'} with you.`}
                {' '}
                View in
                <Accent> Discover</Accent>
              </Text>
              {isMobile ? (
                <AButton href="https://route.onelink.me/sBAP/c486efc7">
                  Get App
                </AButton>
              ) : (
                <Button onClick={() => setModalOpen(true)}>Get App</Button>
              )}
            </TextAndButton>
          </Flex>
        </Scroll>
      </Background>
      <DownloadModal
        isOpen={modalOpen}
        close={() => setModalOpen(false)}
        contentLabel="Send link to download app"
      />
    </>
  )
}

Default.propTypes = {
  type: oneOf(['merchant', 'product', 'story', 'collection']),
}

Default.defaultProps = {
  type: null,
}

export default Default
